import React from "react";
import { useParams, Link } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import { Icon } from "@iconify/react";
import projects from "./projectsData";
import NextProjectButton from "./components/NextProjectButton";
import NavbarHeader from "../Navbarheader/NavbarHeader";
import Footer from "../Footer/Footer";

function TechPill({ tech }) {
  const pillStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: "0.5rem",
    padding: "0.3rem 0.5rem",
    borderRadius: "7px",
    background: "#f5f7ffff",
    border: "1px solid #ebecf6ff",
    color: "#505050ff",
    fontSize: "0.78rem",
  };

  

 

  return (
    <div style={pillStyle} title={tech.name}>
      <div>{tech.name}</div>
    </div>
  );
}

export default function ProjectDetailDynamic() {
  const { slug } = useParams();
  const project = projects.find((p) => p.slug === slug);

  const btnStyle = {
    fontSize: 0.77 + "rem",
    color: "#64748B",
  };

  if (!project) {
    return (
      <div style={{ padding: "4rem" }}>
        <h3>Project not found</h3>
        <p>
          The project you requested does not exist. Go back to the{" "}
          <Link to="/project">projects list</Link>.
        </p>
      </div>
    );
  }

  return (
    <div fluid className="scroll-container">
      <NavbarHeader />
      <div
        className="container-section"
        style={{
          backgroundColor: "white",
          color: "#0f0f0f",
          paddingTop: "5rem",
          paddingBottom: "4rem",
        }}
      >
        <Row>
          <Col md={6}>
            <img
              src={project.displayImageUrl || "/placeholder.jpg"}
              alt={project.title}
              style={{ width: "100%", borderRadius: 8 }}
            />
          </Col>
          <Col md={6}>
            <h2 style={{ fontFamily: "Clash Display" }}>{project.title}</h2>

            <>
              {/* Render non-HTML items in a single UL */}
              {project.description.filter((p) => !p.includes("<ul>")).length >
                0 && (
                <ul
                  style={{
                    fontSize: "0.83rem",
                    lineHeight: "170%",
                    paddingLeft: 0,
                  }}
                >
                  {project.description
                    .filter((p) => !p.includes("<ul>"))
                    .map((p, idx) => (
                      <li  key={idx}>{p}</li>
                    ))}
                </ul>
              )}

              {/* Render HTML UL items as they are */}
              {project.description
                .filter((p) => p.includes("<ul>"))
                .map((p, idx) => (
                  <div
                    key={idx}
                    style={{ fontSize: "0.83rem", lineHeight: "170%", paddingLeft:"-40rem" }}
                    dangerouslySetInnerHTML={{ __html: p }}
                  />
                ))}
            </>

            <div
              style={{
                display: "flex",
                gap: 10,
                flexWrap: "wrap",
                marginTop: 12,
                marginBottom: 12,
              }}
            >
              {project.languages.map((tech) => (
                <TechPill tech={tech} key={tech.name} />
              ))}
            </div>

            <div style={{ display: "flex", gap: 12, marginTop: 18 }}>
              <Button
                variant="light"
                as="a"
                href={project.visitLink}
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center gap-2"
              >
                <span style={btnStyle}>Visit site</span>
                <Icon style={btnStyle} icon="lucide:external-link" />
              </Button>

              <Button
                variant="light"
                as="a"
                href={project.figmaLink}
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center gap-2"
              >
                <span style={btnStyle}>View Figma</span>
                <Icon style={btnStyle} icon="lucide:figma" />
              </Button>
            </div>
          </Col>
        </Row>
      </div>
      <NextProjectButton currentProjectId={project.id} />
      <Footer />
    </div>
  );
}
